"use strict";

var _ = require("lodash");

function SettingsOrgUserDetailsController(
  $state,
  $stateParams,
  $scope,
  OrganizationStore,
  SaturnGrowl,
  SettingsActions
) {
  var vm = this;
  // vm.isEditing = false;
  // vm.permissionLevels = ['Admin', 'Pilot', 'User'];
  _formatUser($stateParams.user).then(user => {
    vm.user = user;
    vm.sites = vm.user.sites;
    SettingsActions.OpenDetailView.dispatch();
  });

  // function growl (user, type) {
  //   var growl;

  //   if (type === 'denied' || type === 'approved') {
  //     growl = [user.firstName, ' ', user.lastName, '\'s request to join ', vm.org.name, ' has been ', type ,' .'].join('');
  //   } else if (type === 'invitation') {
  //     growl = ['An invite has been sent to', vm.user.firstName, vm.user.lastName].join(' ');
  //   } else if (type === 'resetPassword') {
  //     growl = [vm.user.firstName, ' ', vm.user.lastName, '\'s password has been reset. Instructions have been emailed to ', vm.user.email, '.'].join('');
  //   }

  //   SaturnGrowl.newGrowl(growl, {
  //     type: 'normal'
  //   });
  // }

  /**======== Button Actions ========**/
  // vm.editUser = function editUser () {
  //   vm.isEditing = !vm.isEditing;
  // };

  // vm.save = function save () {
  //   console.log('saving');
  // };

  // vm.resetPassword = function resetPassword () {
  //   SettingsActions.ResetPassword.dispatch(vm.user);
  // };

  // vm.resendInvitation = function resendInvitation () {
  //   SettingsActions.ResendInvitation.dispatch(vm.user);
  // };

  // vm.deactivateUser = function deactivateUser () {
  //   SettingsActions.OpenDialog.dispatch(vm.user);
  // };

  vm.closeUserView = function closeUserView() {
    $state.go("settings.organization.users");
    SettingsActions.CloseDetailView.dispatch();
  };

  function _formatUser(userId) {
    /* jshint camelcase: false */

    let user;
    if (!userId) {
      user = _.cloneDeep(OrganizationStore.get("user"));
    } else {
      user = OrganizationStore.get("users").filter(
        user => user.id === parseInt(userId)
      )[0];
    }

    // var orgAccess = _.find(user.organizations, {
    //   id: OrganizationStore.get("current").id
    // });

    user.permissionLevel = OrganizationStore._getOrgPermissionLevel(
      user._pivot_roleId
    );

    return OrganizationStore.loadUserSites(
      user.id,
      OrganizationStore.get("current")
    ).then(userEnriched => {
      user.sites = userEnriched.userSites.map(function(site) {
        return site.name;
      });
      user.status = user.isDisabled ? "Inactive" : "Active";
      return user;
    });
  }

  /**======     Flux Handlers and Registry    ======**/
  // vm.handleResendInvitation = function handleResendInvitation () {
  //   vm.user = SettingsStore.get('user');
  //   growl(vm.user, 'invitation');
  // };

  // vm.handleResetPassword = function handleResetPassword () {
  //   vm.user = SettingsStore.get('user');
  //   growl(vm.user, 'resetPassword');
  // };

  // SettingsStore.on(SettingsStore.Events.ResendInvitation, this.handleResendInvitation.bind(this), $scope);
  // SettingsStore.on(SettingsStore.Events.ResetPassword, this.handleResetPassword.bind(this), $scope);
}

SettingsOrgUserDetailsController.$inject = [
  "$state",
  "$stateParams",
  "$scope",
  "OrganizationStore",
  "SaturnGrowl",
  "SettingsActions"
];

module.exports = SettingsOrgUserDetailsController;



// WEBPACK FOOTER //
// ./src/app/settings/orgUsers/SettingsOrgUserDetailsController.js